import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./admin.css"; 
import { greeting } from "../../portfolio.js"; // Importar los datos necesarios

function Admin() {
  const history = useHistory();
  const [titulo, setTitulo] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [imagen, setImagen] = useState(null);
  const [enlace, setEnlace] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [proyectos, setProyectos] = useState([]);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("loggedIn");
    if (!isLoggedIn) {
      history.push("/login"); // Redirigir a la página de login si no está autenticado
    }

    fetchProyectos();
  }, [history]);

  const fetchProyectos = async () => {
    try {
      const response = await fetch("https://mikalet.com/api/portfolio/proyectos_admin.php");
      const data = await response.json();
      console.log(data); // Verificar la estructura de los datos
      setProyectos(data);
    } catch (error) {
      console.error("Error al obtener proyectos:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("titulo", titulo);
    formData.append("descripcion", descripcion);
    formData.append("imagen", imagen);
    formData.append("enlace", enlace);

    try {
      const response = await fetch("https://mikalet.com/api/portfolio/subir_proyecto.php", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      setMensaje(data.message);

      if (data.success) {
        setTitulo("");
        setDescripcion("");
        setImagen(null);
        setEnlace("");
        fetchProyectos(); // Recargar lista de proyectos después de agregar uno nuevo
      }
    } catch (error) {
      console.error("Error al subir proyecto:", error);
    }
  };

  const handleHide = async (id) => {
    if (!window.confirm("¿Seguro que quieres ocultar este proyecto?")) return;

    try {
      const response = await fetch("https://mikalet.com/api/portfolio/proyectos_admin.php", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      const data = await response.json();
      setMensaje(data.message);
      fetchProyectos(); // Recargar la lista después de ocultar
    } catch (error) {
      console.error("Error al ocultar proyecto:", error);
    }
  };

  const handleActivate = async (id) => {
    if (!window.confirm("¿Seguro que quieres activar este proyecto?")) return;

    try {
      const response = await fetch("https://mikalet.com/api/portfolio/proyectos_admin.php?activate=1", {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      const data = await response.json();
      setMensaje(data.message);
      fetchProyectos(); // Recargar la lista después de activar
    } catch (error) {
      console.error("Error al activar proyecto:", error);
    }
  };

  return (
    <div className="backend-container">
      <h2>Subir Nuevo Proyecto</h2>
      <form onSubmit={handleSubmit} className="upload-form">
        <label>Título:</label>
        <input
          type="text"
          value={titulo}
          onChange={(e) => setTitulo(e.target.value)}
          required
        />

        <label>Descripción:</label>
        <textarea
          value={descripcion}
          onChange={(e) => setDescripcion(e.target.value)}
          required
        ></textarea>

        <label>Imagen:</label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImagen(e.target.files[0])}
          required
        />

        <label>Enlace del Proyecto:</label>
        <input
          type="text"
          value={enlace}
          onChange={(e) => setEnlace(e.target.value)}
        />

        <button type="submit">Subir Proyecto</button>
      </form>

      {mensaje && <p>{mensaje}</p>}

      <h3>Proyectos Activos</h3>
      <div className="project-list">
        {proyectos.filter(p => Number(p.visible) === 1).map((proyecto) => (
          <div key={proyecto.id} className="project-card-admin">
            <h3>{proyecto.titulo}</h3>
            <p>{proyecto.descripcion}</p>
            <img className="project-card-image-admin" src={proyecto.imagen} alt={proyecto.titulo} />
            <button className="hide-btn" onClick={() => handleHide(proyecto.id)}>
              Ocultar
            </button>
          </div>
        ))}
      </div>

      <h3>Proyectos Ocultos</h3>
      <div className="project-list">
        {proyectos.filter(p => Number(p.visible) === 0).map((proyecto) => (
          <div key={proyecto.id} className="project-card-admin hidden-project">
            <h3>{proyecto.titulo}</h3>
            <p>{proyecto.descripcion}</p>
            <img className="project-card-image-admin" src={proyecto.imagen} alt={proyecto.titulo} />
            <button  className="activate-btn" onClick={() => handleActivate(proyecto.id)}>
              Activar
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Admin;